<template>
  <div class="queue-task-tip">
    <el-dialog
      :title="'[年度诉讼明细]'+year_month"
      :visible.sync="visible"
      width="90vw"
      :before-close="handleClose">
      <YearLitigationLayout v-if="visible" :project_id="projectId" :year_month="year_month" />
    </el-dialog>
  </div>
</template>

<script>
import YearLitigationLayout from "./YearLitigationLayout";
import moment from "moment";
export default {
  name: "YaerLitigationHouseTip",
  components: {YearLitigationLayout},
  data() {
    return {
      visible: false,
      projectId: "",
      year_month: moment().format("YYYY-MM")
    };
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    show(projectId,year_month) {
      this.projectId = projectId*1;
      this.year_month = year_month;
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.queue-task-tip {
  position: relative;
}
.queue-task-tip{
  /deep/.el-dialog__body {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/YaerLitigationHouseTip.vue